// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { MapSymbolDefinition_abstract } from './../../abstract/SagaBase/Objects/MapSymbolDefinition_abstract';
export class MapSymbolDefinition extends MapSymbolDefinition_abstract {}
